"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionHandler = exports.isNolimitBonusPromoData = exports.isFreeBetsPromoData = void 0;
const APIEventSystem_1 = require("../../../interfaces/APIEventSystem");
const Logger_1 = require("../../../utils/Logger");
const FreeBetsTemplate_1 = require("./FreeBetsTemplate");
const APIBetType_1 = require("../../../interfaces/APIBetType");
const ExternalPromotionHandler_1 = require("./ExternalPromotionHandler");
const eventSystem = require('@nolimitcity/core/api/event-system');
/**
 * Created by jonas on 2023-12-05.
 */
function isFreeBetsPromoData(value) {
    return value !== undefined && value.rounds !== undefined && value.used !== undefined;
}
exports.isFreeBetsPromoData = isFreeBetsPromoData;
function isNolimitBonusPromoData(value) {
    return value !== undefined && value.featureName !== undefined && value.bet !== undefined;
}
exports.isNolimitBonusPromoData = isNolimitBonusPromoData;
class PromotionHandler {
    get promotionData() {
        return this._promotionData;
    }
    get activePromotion() {
        return this._promotionData.get(this._activePromoName);
    }
    constructor(api) {
        this._ready = false;
        this.FREE_BETS_START = "freeBetsStart";
        this.FREE_BETS_UPDATE = "freeBetsUpdate";
        this.FREE_BETS_END = "freeBetsEnd";
        this.FREE_BETS_START_FROM_ACTION_SPINS = "freeBetsStartFromActionSpins";
        this.FREE_FEATURE_BET_START = "freeFeatureBetStart";
        this.FREE_FEATURE_BET_UPDATE = "freeFeatureBetUpdate";
        this.FREE_FEATURE_BET_END = "freeFeatureBetEnd";
        this._activePromoName = "";
        this._isRestoreState = false;
        this._promotionData = new Map();
        this._api = api;
        this.events = eventSystem.create();
        this.externalPromotionHandler = new ExternalPromotionHandler_1.ExternalPromotionHandler(this, api);
        api.events.on(APIEventSystem_1.APIEvent.IS_OPEN_GAME_ROUND, (value) => this.onRestore(value));
        api.events.on(APIEventSystem_1.APIEvent.READY, () => this.onReady());
        api.events.on(APIEventSystem_1.APIEvent.FREE_BETS, (data) => this.onPromoData(data));
        api.events.on(APIEventSystem_1.APIEvent.FREE_FEATURE_BETS, (data) => this.onPromoData(data));
        api.events.on(APIEventSystem_1.APIEvent.SOFT_RESET, () => this.onSoftReset());
        api.events.on(APIEventSystem_1.APIEvent.BET, (data) => this.onBet(data));
        api.events.on(APIEventSystem_1.APIEvent.ACTION_SPINS_BET, (data) => this.onBet(data));
        api.events.on(APIEventSystem_1.APIEvent.GAME, (data) => this.onGameData(data));
        api.events.on(APIEventSystem_1.APIEvent.INIT, (data) => this.onInit(data));
        api.events.on(APIEventSystem_1.APIEvent.REDIRECTING_TO_BONUS_IN_GAME, (data) => this.onPlayBonusInGame(data));
        api.events.on(APIEventSystem_1.APIEvent.REDIRECTING_TO_BONUS_IN_GAME_COMPLETE, (data) => this.onPlayBonusInGameComplete(data));
        api.events.on(APIEventSystem_1.APIEvent.EXTERNAL_FREE_ROUNDS_MESSAGES, (operatorFreeBetMessages) => {
            let messages = JSON.parse(operatorFreeBetMessages);
            messages = Array.isArray(messages) ? messages : [messages];
            this._operatorFreeBetMessages = messages;
        });
    }
    onPlayBonusInGame(data) {
        this._api.dialog.lock("playBonusInGame");
    }
    onPlayBonusInGameComplete(data) {
        this._api.dialog.unlock("playBonusInGame");
    }
    onInit(data) {
        //This subtracts current pending win from FB total during restore.
        if (this._isRestoreState && this._startUpData) {
            if (isFreeBetsPromoData(this._startUpData)) {
                if (data.accumulatedRoundWin) {
                    this._startUpData.winnings = this._api.currency.formatValue((+this._startUpData.winnings) - data.accumulatedRoundWin);
                }
            }
        }
    }
    onGameData(data) {
        this.setTotalWin(data.accumulatedRoundWin);
    }
    onReady() {
        this._ready = true;
        if (this._startUpData) {
            this.onPromoData(this._startUpData);
            this._startUpData = undefined;
        }
    }
    onRestore(value) {
        this._isRestoreState = value;
        if (this._isRestoreState) {
            if (this._startUpData && isFreeBetsPromoData(this._startUpData)) {
                this._startUpData.count = this._startUpData.count - 1;
                this._startUpData.used = this._startUpData.used + 1;
            }
        }
    }
    onPromoData(data) {
        if (this._api.isReplay) {
            return;
        }
        if (!this._ready) {
            this._startUpData = data;
            return;
        }
        //End normal freebets
        if (isFreeBetsPromoData(data) && data.previous !== undefined) {
            if (this._activePromoName == data.previous.promoName) {
                this._promotionData.set(data.previous.promoName, data.previous);
                this.events.trigger(this.FREE_BETS_UPDATE);
                this._promotionData.delete(data.previous.promoName);
                this._activePromoName = "";
                this.showEndDialog(data.previous).then(() => {
                    this.events.trigger(this.FREE_BETS_END);
                });
            }
        }
        if (data.promoName == undefined) {
            return;
        }
        if (this._promotionData.has(data.promoName)) {
            //Update,
            this._promotionData.set(data.promoName, data);
        }
        else {
            //new data
            //TODO - This prevents the client from displaying more than one ticket at a time. This should be removed when the the FB queue is removed on platform side.
            if (this._promotionData.size >= 1) {
                return;
            }
            this._promotionData.set(data.promoName, data);
            if (isFreeBetsPromoData(data)) {
                if (data.used > 0) {
                    //Is game re-launched.
                    //If round is restored.
                    //data.count = data.count -1;
                    this._activePromoName = data.promoName;
                    this.events.trigger(this.FREE_BETS_START);
                }
                if (data.count > 0) {
                    this.showStartDialog(data);
                }
            }
            else if (isNolimitBonusPromoData(data)) {
                if (this._isRestoreState) {
                    this._activePromoName = data.promoName;
                    this.events.trigger(this.FREE_FEATURE_BET_START);
                    this.nolimitBonusFreeBetStarted();
                }
                else {
                    this.showStartDialog(data);
                }
            }
        }
    }
    showStartDialog(data) {
        this._api.betHandler.cancelNextAutoBetAfterCollect();
        let html = "";
        let dialogData = {};
        let promoValue = "-1";
        if (isFreeBetsPromoData(data)) {
            promoValue = this._api.currency.format(data.rounds * parseFloat(data.amount));
            let spinsToGoText = this._api.translations.translate("#spinstogo out of #spinsleft spins to go");
            spinsToGoText = spinsToGoText.replace("#spinstogo", "" + data.count);
            spinsToGoText = spinsToGoText.replace("#spinsleft", "" + (data.rounds));
            dialogData = {
                header: this._api.translations.translate('Congratulations!'),
                message: this._api.translations.translate('You have free bets!'),
                operatorFreeBetMessages: this._operatorFreeBetMessages,
                value: promoValue,
                choice: this.activePromotion == undefined,
                count: data.count,
                total: data.count + data.used,
                spinsToGo: spinsToGoText,
            };
            html = this._api.translations.render(FreeBetsTemplate_1.FreeBetsTemplate.NEW_START_TEMPLATE, dialogData);
        }
        else if (isNolimitBonusPromoData(data)) {
            dialogData = {
                header: this._api.translations.translate('Congratulations!'),
                message: this._api.translations.translate("You have been awarded a Nolimit Bonus!"),
                operatorFreeBetMessages: this._operatorFreeBetMessages,
                value: this._api.currency.format(data.totalAmount),
                choice: this.activePromotion == undefined
            };
            html = this._api.translations.render(FreeBetsTemplate_1.FreeBetsTemplate.NEW_START_TEMPLATE, dialogData);
        }
        const dialog = this._api.dialog.open(html, {
            alwaysShow: true,
            closeable: false,
            onShowCB: () => { },
            onClose: () => { }
        });
        this.addOnClickToElement(dialog, ".continueNow", () => {
            var _a;
            (_a = this._api.autoplayPlugin) === null || _a === void 0 ? void 0 : _a.cancelAutoPlay();
            this.setActivePromo(data.promoName || "");
            this._api.dialog.close();
        });
        this.addOnClickToElement(dialog, ".playNow", () => {
            var _a;
            (_a = this._api.autoplayPlugin) === null || _a === void 0 ? void 0 : _a.cancelAutoPlay();
            this.openVoucherMenu();
            this._api.dialog.close();
        });
        this.queuedDialog = dialog;
    }
    addOnClickToElement(dialog, qs, cb) {
        const btn = dialog.querySelector(qs);
        if (btn != null) {
            btn.onclick = () => {
                cb();
            };
        }
    }
    openVoucherMenu() {
        this._api.slotStates.stateIsReady().then(() => {
            var _a;
            (_a = this._api.promoPanel) === null || _a === void 0 ? void 0 : _a.open();
        });
    }
    showEndDialog(data) {
        return new Promise((resolve) => {
            this._api.betHandler.cancelNextAutoBetAfterCollect();
            let defaultEndMessage = {
                winnings: "-1",
                aWinnerIsYou: false
            };
            if (isFreeBetsPromoData(data)) {
                defaultEndMessage = {
                    winnings: data.winnings,
                    aWinnerIsYou: parseFloat(data.winnings) > 0
                };
            }
            else if (isNolimitBonusPromoData(data)) {
                const winAmount = data.totalWin != undefined ? +data.totalWin : 0;
                defaultEndMessage = {
                    winnings: this._api.currency.formatValue(winAmount),
                    aWinnerIsYou: winAmount > 0
                };
            }
            const dialogData = defaultEndMessage;
            const html = this._api.translations.render(FreeBetsTemplate_1.FreeBetsTemplate.END_TEMPLATE, dialogData);
            this._api.dialog.open(html, {
                alwaysShow: true,
                closeable: false,
                onClose: () => {
                    resolve();
                }
            });
        });
    }
    nolimitBonusFreeBetStarted() {
        this._api.slotStates.stateIsReady().then(value => {
            if (this.activePromotion) {
                const endData = this.activePromotion;
                this._promotionData.delete(endData.promoName);
                this._activePromoName = "";
                this.showEndDialog(endData).then(() => {
                    this.events.trigger(this.FREE_FEATURE_BET_END);
                    this._api.betFeatureController.setActiveBetFeature(); //remove feature bet.
                });
            }
        });
    }
    startPromoInGame(promoName) {
        var _a, _b;
        if (this.setActivePromo(promoName)) {
            //close promo panel if open
            if (isFreeBetsPromoData(this.activePromotion)) {
                (_a = this._api.promoPanel) === null || _a === void 0 ? void 0 : _a.close();
                this.events.trigger(this.FREE_BETS_START);
                this._api.slotStates.stateIsReady().then(() => {
                    this._api.betHandler.bet();
                });
            }
            else if (isNolimitBonusPromoData(this.activePromotion)) {
                const promoData = this.activePromotion;
                (_b = this._api.promoPanel) === null || _b === void 0 ? void 0 : _b.close();
                this.events.trigger(this.FREE_FEATURE_BET_START);
                this._api.betLevel.setLevel(this._api.currency.formatValue(promoData.bet));
                this._api.betFeatureController.setActiveBetFeature(promoData.featureName);
                this._api.betHandler.freeFeatureBet(promoData, {});
                this._api.events.once(APIEventSystem_1.APIEvent.BET, (data) => {
                    if (data.featureName == promoData.featureName && data.data.isPromotional == true) {
                        this.nolimitBonusFreeBetStarted();
                    }
                });
            }
        }
    }
    startPromoInActionSpins(promoName) {
        if (this.setActivePromo(promoName)) {
            if (this._api.promoPanel) {
                let bonusFeatureName = undefined;
                if (isNolimitBonusPromoData(this.activePromotion)) {
                    bonusFeatureName = this.activePromotion.featureName;
                    this.events.trigger(this.FREE_FEATURE_BET_START);
                    this.nolimitBonusFreeBetStarted();
                }
                else {
                    this.events.trigger(this.FREE_BETS_START);
                }
                this._api.promoPanel.startFreeBetsActionSpin(bonusFeatureName);
            }
        }
    }
    setActivePromo(promoName) {
        if (this._promotionData.has(promoName)) {
            this._activePromoName = promoName;
            return true;
        }
        else {
            Logger_1.Logger.warn("Cannot find promo with name: " + promoName);
            return false;
        }
    }
    onBet(data) {
        this._isRestoreState = false;
        if (data.type === APIBetType_1.APIBetType.FREE_BET) {
            if (isFreeBetsPromoData(this.activePromotion)) {
                this.activePromotion.count = Math.max(this.activePromotion.count - 1, 0);
                this.events.trigger(this.FREE_BETS_UPDATE);
            }
        }
        if (this.externalPromotionHandler.hasExternalPromo()) {
            this.externalPromotionHandler.onBet(data);
        }
    }
    onSoftReset() {
        if (isFreeBetsPromoData(this.activePromotion)) {
            this.activePromotion.count = Math.max(this.activePromotion.rounds - this.activePromotion.used, 0);
            this.events.trigger(this.FREE_BETS_UPDATE);
        }
        if (this.externalPromotionHandler.hasExternalPromo()) {
            this.externalPromotionHandler.onSoftReset();
        }
    }
    //FREE BET interface
    start() {
        //This is run when apiPlugin runs it's start phase.
    }
    /**
     * Return true if it has active freebets that are NOT feature bets
     */
    hasFreeBets() {
        return this.hasNormalFreeBets() || this.externalPromotionHandler.hasExternalPromo();
    }
    /**
     * Return true if it has active "normal" nolimit freebets
     */
    hasNormalFreeBets() {
        return isFreeBetsPromoData(this.activePromotion);
    }
    /**
     * Return true if it has active Feature Bet free bet.
     */
    hasFreeFeatureBet() {
        return isNolimitBonusPromoData(this.activePromotion);
    }
    /**
     * Return true if it has active external freebets.
     */
    hasExternalFreeBet() {
        return this.externalPromotionHandler.hasExternalPromo();
    }
    getFormattedWin() {
        const win = this.getCurrentWinnings();
        if (win != undefined && win > 0) {
            return this._api.currency.format(win);
        }
        return undefined;
    }
    getCurrentWinnings() {
        const activePromo = this.activePromotion;
        if (activePromo) {
            if (isNolimitBonusPromoData(activePromo)) {
                return undefined;
            }
            else if (isFreeBetsPromoData(activePromo)) {
                return parseFloat(activePromo.winnings) > 0 ? parseFloat(activePromo.winnings) : undefined;
            }
        }
        if (this.externalPromotionHandler.hasExternalPromo()) {
            return this.externalPromotionHandler.getCurrentWinnings();
        }
        return undefined;
    }
    getBetHeader() {
        let text = this._api.translations.translate("BET");
        const activePromo = this.activePromotion;
        if (activePromo) {
            if (isNolimitBonusPromoData(activePromo)) {
                text = this._api.translations.translate('FREE BET');
            }
            else if (isFreeBetsPromoData(activePromo)) {
                const count = activePromo.count;
                const header = count === 1 ? 'FREE BET' : 'FREE BETS';
                const translated = this._api.translations.translate(header);
                text = count + " " + translated;
            }
        }
        if (this.externalPromotionHandler.hasExternalPromo()) {
            return this.externalPromotionHandler.getBetHeader();
        }
        return text;
    }
    getBet() {
        const activePromo = this.activePromotion;
        if (activePromo) {
            if (isNolimitBonusPromoData(activePromo)) {
                return this._api.currency.formatValue(activePromo.bet);
            }
            else if (isFreeBetsPromoData(activePromo)) {
                return activePromo.amount;
            }
        }
        if (this.externalPromotionHandler.hasExternalPromo()) {
            return this.externalPromotionHandler.getBet();
        }
        return this._api.currency.formatValue(0);
    }
    getRemainingRounds() {
        const activePromo = this.activePromotion;
        if (activePromo) {
            if (isNolimitBonusPromoData(activePromo)) {
                return 1;
            }
            else if (isFreeBetsPromoData(activePromo)) {
                return activePromo.count;
            }
        }
        if (this.externalPromotionHandler.hasExternalPromo()) {
            return this.externalPromotionHandler.getRemainingRounds();
        }
        return 0;
    }
    // IFreeFeatureBet interface
    setTotalWin(totalWin) {
        if (isNolimitBonusPromoData(this.activePromotion)) {
            this.activePromotion.totalWin = totalWin;
        }
    }
}
exports.PromotionHandler = PromotionHandler;
//# sourceMappingURL=PromotionHandler.js.map